import Page from "components/Layout/Page/Page";
import { Stack, IconButton } from "@mui/material";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoginStepClientCode from "./components/LoginStepClientCode/LoginStepClientCode";
import LoginStepCpfCnpj from "./components/LoginStepCpfCnpj/LoginStepCpfCnpj";
import LoginStepPassword from "./components/LoginStepPassword";
import HelpModal from "components/DataDisplay/HelpModal/HelpModal";
import { useHistory } from "react-router-dom";

export default function Login() {
  const [loginStep, setLoginStep] = useState("cpfCnpj");
  const [segment, setSegment] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [cpfAccess, setCpfAccess] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [openHelpModal, setOpenHelpModal] = useState(false);

  const router = useHistory();

  const featureFlagNovaFormaAcessoContaSim = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_CONTASIM === "true";

  const onSuccessConsultCpfCnpj = (response, cpfCnpj, cpfAccess) => {
    const accountIsActived = response["tipo-conta"] !== "INATIVO";
    const accountIsIndustrial = response["tipo-conta"] === "INDUSTRIAL";
    const accountIsLicitacao = response["tipo-conta"] === "LICITACAO";
    const accountNotFound = response["tipo-conta"] === "";
    const accountHasPassword = response["senha-cadastrada"] === "Sim";

    if (accountIsIndustrial) {
      setCpfAccess(cpfAccess);
      setCpfCnpj(cpfCnpj);
      setSegment(response["tipo-conta"]);
      setUserEmail(response.email);
      return setLoginStep(!accountHasPassword ? "clientCode" : "password");
    }

    if (accountIsLicitacao) {
      setCpfAccess(cpfAccess);
      setCpfCnpj(cpfCnpj);
      setSegment(response["tipo-conta"]);
      setUserEmail(response.email);
      return setLoginStep(!accountHasPassword ? "clientCode" : "password");
    }

    if (accountNotFound) {
      return router.push({
        pathname: "/register-client",
        state: { cpfCnpj, existentClient: false, accountHasPassword },
      });
    }

    if (!accountIsActived) {
      return setOpenHelpModal(true);
    }

    setCpfCnpj(cpfCnpj);
    setSegment(response["tipo-conta"]);
    setUserEmail(response.email);
    setLoginStep((!accountHasPassword || !featureFlagNovaFormaAcessoContaSim) ? "clientCode" : "password");
  };

  const steps = {
    cpfCnpj: (
      <LoginStepCpfCnpj onSuccessConsultCpfCnpj={onSuccessConsultCpfCnpj} />
    ),
    clientCode: (
      <LoginStepClientCode
        segment={segment}
        cpfCnpj={cpfCnpj}
        cpfAccess={cpfAccess}
      />
    ),
    password: (
      <LoginStepPassword
        segment={segment}
        cpfCnpj={cpfCnpj}
        cpfAccess={cpfAccess}
        email={userEmail}
      />
    ),
  };

  return (
    <Page>
      <Stack
        justifyContent={"center"}
        alignItems="center"
        height="100vh"
        textAlign={"center"}
      >
        {loginStep !== "cpfCnpj" && (
          <IconButton
            onClick={() => setLoginStep("cpfCnpj")}
            sx={{ position: "absolute", p: 0, top: 60, left: 100 }}
          >
            <ArrowBackIcon sx={{ color: "#fff", fontSize: "31px" }} />
          </IconButton>
        )}
        <Stack
          width={"100%"}
          justifyContent={"center"}
          alignItems={"center"}
          maxWidth={"660px"}
        >
          {steps[loginStep]}
        </Stack>
      </Stack>
      <HelpModal open={openHelpModal} onClose={() => setOpenHelpModal(false)} />
    </Page>
  );
}
